import React, { useEffect, useState } from "react";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { getvehicleType } from "../../store/slices/vehicletype";
import { toast } from "react-toastify";
import Select from "react-select";

export default function EditQuotationCarStep({
  packageId,
  cars,
  setCars,
  nextStep,
  prevStep,
}) {
  const dispatch = useDispatch();

  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [errors, setErrors] = useState([]);

useEffect(() => {

  const fetchVehicleTypes =
    async () => {

      try {

        const res =
          await dispatch(
            getvehicleType()
          ).unwrap();

        setVehicleTypes(
          res?.vehicles || []
        );

      } catch (err) {

        toast.error(
          "Failed to load vehicle types"
        );

      }
    };

  fetchVehicleTypes();

}, [dispatch]);


  const handleChange = (actualIndex, field, value) => {
    const updated = [...cars];
    const newErrors = [...errors];

    if (!newErrors[actualIndex]) newErrors[actualIndex] = {};

    if (field === "vehicleType") {
      if (!value) {
        newErrors[actualIndex].vehicleType = "Please select vehicle type";
      } else {
        newErrors[actualIndex].vehicleType = "";
      }
    }

    if (field === "remarks") {
      if (value && !/^[a-zA-Z\s.,-]*$/.test(value)) {
        newErrors[actualIndex].remarks = "Only letters allowed";
        return; // block numbers
      } else {
        newErrors[actualIndex].remarks = "";
      }
    }

    if (field === "pricePerDay") {
      if (!value) {
        newErrors[actualIndex].pricePerDay = "Please enter price per day";
      } else if (!/^\d+$/.test(value)) {
        newErrors[actualIndex].pricePerDay = "Only numbers allowed";
        return;
      } else {
        newErrors[actualIndex].pricePerDay = "";
      }
    }

    updated[actualIndex][field] = value;
    setCars(updated);
    setErrors(newErrors);
  };

  const validateVehicleForm = () => {
    let isValid = true;
    const newErrors = [];

    cars.forEach((config, index) => {
      newErrors[index] = {};

      if (!config.vehicleType) {
        newErrors[index].vehicleType = "Please select vehicle type";
        isValid = false;
      }

      if (config.remarks && !/^[a-zA-Z\s.,-]*$/.test(config.remarks)) {
        newErrors[index].remarks = "Only letters allowed";
        isValid = false;
      }
      if (!config.pricePerDay) {
        newErrors[index].pricePerDay = "Please enter price per day";
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (!validateVehicleForm()) return;

    try {
     
      nextStep();
    } catch (err) {
      toast.error("Failed to save vehicles");
    }
  };


const carsByOption =
  Object.values(
    cars.reduce(
      (acc, car) => {

        const optionId =
          car.packageOption;

        if (!acc[optionId]) {

          acc[optionId] = {
            option: {
              _id: optionId,

              name:
                car
                  ?.packageOptionName ||

                "Option",
            },

            configs: [],
          };
        }

        acc[optionId].configs.push(
          car
        );

        return acc;

      },
      {}
    )
  );

  return (
    <Container>
      <Card className="p-4 shadow-sm border-0 mt-2">
<Row>
  {carsByOption.map(
    ({ option, configs }) => (
      <Col md={12} key={option._id}>
        <Card className="p-3 mb-3 shadow-sm">

          <h5 className="text-center mb-3">
            {option.name}
          </h5>



   
{configs.map(
  (config, index) => {

    const actualIndex =
      cars.findIndex(
        (c) =>
          String(c._id) ===
          String(config._id)
      );

    return (


     <Card
                key={index}
                className="mb-4 p-3 border"
              >
                <h6>
                  Day {index + 1}
                </h6>

                <Row className="g-3">

                  {/* Vehicle Type */}
                  <Col md={4}>
                    <Form.Label>
                      Vehicle Type
                    </Form.Label>

                    <Select
                      placeholder="Select Vehicle"

                      value={
                        vehicleTypes
                          .map((vt) => ({
                            value: vt._id,
                            label: vt.name,
                          }))
                          .find(
                            (o) =>
                              String(o.value) ===
                              String(
                                config.vehicleType?._id ||
                                config.vehicleType
                              )
                          ) || null
                      }

                      onChange={(selected) =>
                        handleChange(
                          actualIndex,
                          "vehicleType",
                          selected?.value || ""
                        )
                      }

                      options={vehicleTypes.map(
                        (vt) => ({
                          value: vt._id,
                          label: vt.name,
                        })
                      )}
                    />

                    {errors[actualIndex]
                      ?.vehicleType && (
                      <small className="text-danger">
                        {
                          errors[actualIndex]
                            .vehicleType
                        }
                      </small>
                    )}
                  </Col>

                  {/* Price */}
                  <Col md={4}>
                    <Form.Label>
                      Price Per Day
                    </Form.Label>

                    <Form.Control
                      type="number"
                      min="0"

                      value={
                        config.pricePerDay ??
                        config.price ??
                        0
                      }

                      placeholder="Enter price"

                      onChange={(e) =>
                        handleChange(
                          actualIndex,
                          "pricePerDay",
                          e.target.value
                        )
                      }
                    />

                    {errors[actualIndex]
                      ?.pricePerDay && (
                      <small className="text-danger">
                        {
                          errors[actualIndex]
                            .pricePerDay
                        }
                      </small>
                    )}
                  </Col>

                  {/* Remarks */}
                  <Col md={4}>
                    <Form.Label>
                      Remarks
                    </Form.Label>

                    <Form.Control
                      as="textarea"
                      rows={2}

                      value={
                        config.remarks || ""
                      }

                      placeholder="Optional remarks"

                      onChange={(e) =>
                        handleChange(
                          actualIndex,
                          "remarks",
                          e.target.value
                        )
                      }
                    />
                  </Col>

                </Row>
              </Card>
              
             
            );
           } )}

        </Card>
         <div className="d-flex justify-content-between mt-4 mb-5">
          <button className="cancel-btn" onClick={prevStep}>
            Previous
          </button>

          <button className="submit-btn" onClick={handleSubmit}>
            Next
          </button>
        </div>
      </Col>
    )
  )}
</Row>
</Card>
    </Container>
  );
}
